var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrasil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#229e45",
    fillRule: "evenodd",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8e509",
    fillRule: "evenodd",
    d: "m321 436 302-196L320 44 17 241l304 195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b49a3",
    fillRule: "evenodd",
    d: "M453 240a127 127 0 1 1-255 0 127 127 0 0 1 255 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m283 316-4-2-4 2 1-5-3-3h5l2-4 2 4 4 1-3 3m86 26-4-2-4 2 1-5-4-3 5-1 2-4 2 4 4 1-3 3m-36-30-3-2-4 2 1-4-3-3h4l2-4 1 4 4 1-3 2m87-8-3-2-4 2 1-4-2-3h3l2-4 2 4h4l-3 3m-88-22-4-2-4 2 1-5-3-3 5-1 2-4 2 5h4l-3 3m-105-34-4-3-4 2 1-4-3-4h4l2-4 2 4 5 1-3 3m13 57-4-2-4 2 1-5-3-3 4-1 2-4 2 5h5l-4 4m132-68-3-2-4 2 1-4-3-3h4l2-4 2 4h4l-3 3m-7 38-3-1-3 1 1-3-2-2 3-1 1-2 2 2 3 1-3 2m-142 51-2-2-3 1 1-3-3-2h3l2-3 1 3h3l-2 3m200 15-2-1-2 1v-3l-2-1 3-1 1-2 1 2 2 1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219 288-2-2-3 1 1-3-3-2h3l2-3 1 3h3l-2 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffef",
    fillRule: "evenodd",
    d: "m219 288-2-2-3 1 1-3-3-2h3l2-3 1 3h3l-2 3m42 3-2-2-3 1v-3l-2-2h3l2-3 1 3h3l-2 3m-5 17-3-2-2 1v-3l-2-2h3l2-3 1 3h3l-2 2m87-22-3-1-2 1v-3l-2-2 3-1 1-2 2 2 3 1-3 2m-25 3-2-1-3 1 1-3-2-2 3-1 1-2 1 2 3 1-2 2m-69-6-1-1-2 1v-2l-1-1h2l1-2v2h2l-1 1m168 46-3-2-3 2 1-3-2-3h3l1-3 2 3 3 1-3 2m-21 6-2-2-2 1 1-2-2-2h2l1-3 2 3h2l-2 2m11 2-3-1-2 1 1-2-2-2h3l1-2 1 2h2l-2 2m29-23-2-1-2 1 1-2-2-2h2l1-2 1 2h3l-2 2m-39 42-2-2-3 2 1-3-2-2 3-1 1-2 1 2 3 1-2 2m0 14-2-1-2 1v-3l-2-2h3l1-3 1 3h3l-2 2m-19-23-2-1-2 1 1-2-2-2h2l1-2 1 2h2l-1 2m-18 2-2-1-2 1v-2l-1-2h2l1-2 1 2h2l-1 2m-31-25-2-1-2 1 1-2-2-2h2l1-2 1 2 3 1-2 1m4 57-2-1-2 1 1-2-2-1h2l1-2 1 2h2l-2 1m-46-86-4-3-4 2 1-4-3-4h5l2-4 2 4 4 1-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M444 286c2-5 5-13 6-20-68-59-143-90-239-84l-8 21c113-11 196 39 241 83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m414 252 2 2v2l1 2h4a1 1 0 0 0 0-1l-1-1-1-2-2-3a4 4 0 0 1 2-4l2-1 3 1 3 4-1 3-2-1v-2l-1-2h-2a1 1 0 0 0-1 0v1l1 2 2 3a4 4 0 0 1 0 4 4 4 0 0 1-2 2h-2l-3-1-3-4 1-4zm-12-7 3 1v2l1 2 2 1 1-1a1 1 0 0 0 1-1l-1-1-2-2-1-3v-3a4 4 0 0 1 1-1h3l2 1c2 0 3 1 3 3v3l-3-1v-2l-1-1-2-1h-1v1l2 3 2 2a4 4 0 0 1 0 4 4 4 0 0 1-2 2h-2l-3-1-3-3v-4zm-14-4 8-12 8 5-1 2-6-3-2 2 6 4-1 2-6-4-2 3 7 5-2 2-9-6zm-20-17 1-2 5 3-3 5h-3a9 9 0 0 1-3-1l-3-3a6 6 0 0 1-1-3 9 9 0 0 1 1-4l3-3 3-1 4 1 3 3v3l-3-1v-1l-1-2h-4l-2 2-1 4 2 3h4v-1l-2-2zm-91-22 2-14h5l1 10 3-9 5 1-2 14-3-1 2-11-5 11-2-1-2-11-1 11h-3zm-14-2 1-14 11 1v2h-8v3h7v3l-7-1-1 4 8 1v2l-11-1z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "M217 191v-3a7 7 0 0 1 2-2l1-1 3-1c3 0 4 1 5 2 2 2 2 3 2 6l-2 5-5 2-5-2-2-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7ffff",
    d: "m219 191 1 4 3 1 3-1 1-4-1-3-3-1-2 1-2 3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "M233 199v-15l6 1h3l2 1 1 3-1 2-3 1 1 2 2 2 2 3h-4l-2-3-1-3h-3v6h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M236 190h5l1-1-1-1-1-1h-4v3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "M249 185h5l3 1a5 5 0 0 1 2 1l1 3v6l-2 2-2 1h-8l1-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m252 188-1 9h4l1-1 1-1v-6l-2-1h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m318 210 3-13 4 1 3 1 2 1v3l-1 2-1 1-2 1-3-1h-1l-2 5-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m323 200-1 3 2 1h2a2 2 0 0 0 1-1v-2a2 2 0 0 0-1-1h-3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m331 214 4-13 6 2 3 1 1 2v2l-2 3h-3l1 1 1 3v3l-3-1-1-3v-3l-1-1h-2l-2 5-2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m336 207 2 1 2 1h1l1-1v-2h-1l-2-1-2-1-1 3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m347 214 2-4a7 7 0 0 1 1-1l3-1 3 1c2 0 3 1 4 3v6l-3 4h-6c-2 0-3-1-4-3v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M350 214v4l2 2h3l2-3v-4l-2-2h-3l-2 3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m374 233 7-12 5 2 3 2 1 2c1 1-1 2-1 2l-2 2h-3l1 2v6l-3-2v-6l-1-1-1-1h-1l-2 5-3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m381 227 1 1 3 1h1v-1l1-1-1-1-2-1-2-1-2 3z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m426 259 3-3a7 7 0 0 1 2-1 5 5 0 0 1 2 0l3 1 3 5c0 2 0 3-2 5l-4 4c-2 0-4 0-5-2-2-1-3-2-3-4-1-2 0-3 1-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m429 260-2 4 2 2 3 1 3-2 1-4-2-3h-3l-2 2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#309e3a",
    d: "m302 205 2-10 7 1v2l-5-1-1 2 5 1v2l-5-1-1 2 6 2-1 1-7-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrasil);
export default __webpack_public_path__ + "static/media/brasil.e64a03af4f32b143c6e1e4a574094f55.svg";
export { ForwardRef as ReactComponent };